import { Tooltip } from '@loomhq/lens';
import cn from 'classnames';
import React from 'react';

import styles from './ProgressBar.module.less';

export default function GetStartedProgressBar({ tasks }) {
  return (
    <div className="flex items:center">
      <ol className={styles.taskList}>
        {tasks.map(task => (
          <li key={task.id}>
            <Tooltip content={task.tooltipLabel}>
              <div
                tabIndex="0"
                className={cn(
                  styles.taskItem,
                  !task.isComplete && styles.taskItemIncomplete
                )}
              />
            </Tooltip>
          </li>
        ))}
      </ol>
    </div>
  );
}
